import { useEffect, useRef } from 'react';
import { animate, stagger } from 'animejs';

export function useSlideUp(deps = []) {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) return;
    animate(ref.current, {
      opacity: [0, 1],
      translateY: [28, 0],
      duration: 520,
      easing: 'easeOutExpo',
    });
  }, deps); // eslint-disable-line
  return ref;
}

export function useScaleIn(deps = []) {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) return;
    animate(ref.current, {
      opacity: [0, 1],
      scale: [0.92, 1],
      duration: 420,
      easing: 'easeOutBack',
    });
  }, deps); // eslint-disable-line
  return ref;
}

export function useStaggerUp(deps = []) {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current || !ref.current.children.length) return;
    animate(ref.current.children, {
      opacity: [0, 1],
      translateY: [24, 0],
      delay: stagger(80),
      duration: 500,
      easing: 'easeOutExpo',
    });
  }, deps); // eslint-disable-line
  return ref;
}

export function useSlideDown(deps = []) {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) return;
    animate(ref.current, {
      opacity: [0, 1],
      translateY: [-20, 0],
      duration: 450,
      easing: 'easeOutExpo',
    });
  }, deps); // eslint-disable-line
  return ref;
}
